import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-procedure-table-footer flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "io-mfe-ig-procedure-table-footer-selected-code-label" }, " Selected Code: ", -1)
const _hoisted_3 = { class: "io-mfe-ig-procedure-table-footer-selected-code" }

import {computed} from 'vue';
import { useSearchStore } from 'stores/search-store';
import { useGrouperStore } from 'stores/grouper-store';
import { useHistoryStore } from 'stores/history-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureTableFooter',
  setup(__props) {

const searchStore = useSearchStore();
const history = useHistoryStore<string>('procedure-history');

const codeDisplay = computed(() => {
  let display = searchStore.getSelectedProcedureCode;

  for (let i=searchStore.getSelectedProcedureCode.length; i< 7; i++) {
    display += '_';
  }
  return display
});

function startOver() {
  searchStore.setSelectedProcedureCode('');
}

function addCode() {
  useGrouperStore().addProcedureCode(searchStore.getSelectedProcedureCode, undefined, true);
  history.reinitialize('');
}

const isDisabled = computed(() => searchStore.getSelectedProcedureCode?.length != 7);

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(codeDisplay.value), 1),
    _createVNode(_component_q_space),
    _createElementVNode("a", {
      class: "io-mfe-ig-procedure-table-footer-start-over",
      onClick: startOver
    }, " Start Over "),
    _createVNode(_component_q_btn, {
      unelevated: "",
      outline: "",
      size: "10px",
      disable: isDisabled.value,
      onClick: addCode
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Add Code ")
      ]),
      _: 1
    }, 8, ["disable"])
  ]))
}
}

})